export { buildAhaResult, computeDisplayHeadline } from './src/ahaResult';
export type { AhaMomentResult } from './src/builders';
export type { ScenarioSplits } from './src/builders';
export {
    buildSimulation,
    computeAhaMoment,
    DEPOSIT_APY_PERCENT,
    getScenarioSplits,
    HIGH_INTEREST_DEBT_SPLIT,
    HIGH_INTEREST_EF_SPLIT,
    HIGH_INTEREST_RETIREMENT_SPLIT,
    HIGH_INTEREST_THRESHOLD,
    INVESTMENT_RETURN_PERCENT,
    IRA_ANNUAL_LIMIT_CENTS,
    LOW_INTEREST_DEBT_SPLIT,
    LOW_INTEREST_EF_SPLIT,
    LOW_INTEREST_RETIREMENT_SPLIT,
    MAX_SIMULATION_MONTHS,
    SAVINGS_HI_DEBT_SPLIT,
    SAVINGS_HI_EF_SPLIT,
    SAVINGS_HI_RETIREMENT_SPLIT,
    SAVINGS_HI_SAVINGS_SPLIT,
    SAVINGS_LO_DEBT_SPLIT,
    SAVINGS_LO_EF_SPLIT,
    SAVINGS_LO_RETIREMENT_SPLIT,
    SAVINGS_LO_SAVINGS_SPLIT,
    SAVINGS_ONLY_EF_SPLIT,
    SAVINGS_ONLY_RETIREMENT_SPLIT,
    SAVINGS_ONLY_SAVINGS_SPLIT,
} from './src/builders';
export { SimulationResultsTable } from './src/components/SimulationResultsTable';
export { SimulatorUI } from './src/components/SimulatorUI';
export { runSimulation } from './src/engine';
export type {
    ExistingIraAccount,
    FeeComparison,
    FeeComparisonRow,
    InvestmentWaterfallAccount,
    InvestmentWaterfallResult,
    RothEligibility,
    RothEligibilityDetails,
} from './src/investmentWaterfall';
export {
    allocateEquallyUpToLimits,
    buildInvestmentWaterfall,
    computeDefaultProjectedYears,
    computeProjectedTotal,
    DEFAULT_CONTRIBUTION_RATE,
    DEFAULT_MEMBER_AGE,
    DEFAULT_PROJECTION_YEARS,
    initIntakeInvestment,
    MONTHLY_CONTRIBUTION_STEP_CENTS,
    resolveDefaultAnnualContributionCents,
    roundAnnualContributionToNearestMonthlyStep,
    TAX_YEAR,
    toPersistedInvestmentWaterfall,
} from './src/investmentWaterfall';
export type { PresetOption } from './src/presets';
export { PRESETS } from './src/presets';
export type * from './src/types';
export type { ValidationResult } from './src/validation';
export { MoneyMapSimulationSchema, validateMoneyMap } from './src/validation';
export { formatSaveForGoalLabel, withArticle } from './src/withArticle';
